﻿import * as Res from "./res";
import { createElement, getById, onEvent } from "./_dom";

function onAddItem(_event, button) {
	const ctlId = button.dataset.controlId;
	const baseUrl = button.dataset.multirefAdd;
	const ctl = getById(button.form, ctlId);
	const form = ctl.form, name = ctl.name, value = ctl.value;
	if (ctl.matches("SELECT")) {
		ctl.selectedIndex = 0;
	}
	else {
		ctl.value = "";
		var x = ctl.nextElementSibling;
		x.value = "";
	}
	if (value === "")
		return;

	const vls = value.split('|');
	const key = vls[0], id = vls[1], text = vls[2];
	let keys = form.elements[name];
	if (keys && keys.tagName)
		keys = [keys];
	for (let i = 1; i < keys.length; i++) {
		const ckey = keys[i].value.split('|')[0];
		if (ckey === key)
			return;
	}
	const li = createElement("li",
		{ class: "v3-multiref__listitem" },
		createElement("input", { type: "hidden", name, value: value + "|1" }),
		createElement("a", { target: "_blank", href: baseUrl + '&id=' + encodeURIComponent(id) }, text),
		'\u00a0',
		createElement("button", {
				type: "button",
				class: "v3-multiref__remove v3-button ui-icon-remove ui-icon-only",
				"data-multiref-remove": name
			},
			createElement("span", { class: "ui-icontext" }, Res.getString("form.choice.remove"))
		)
	);
	button.nextElementSibling.appendChild(li);
}

function onRemoveItem(_event, button) {
	const row = button.parentNode;
	const name = button.dataset.multirefRemove;
	// get the primary control before removing the row
	const primary = name && button.form.querySelector(`input[name="${name}"],select[name="${name}"]`);
	row.remove();
	primary.dispatchEvent(new Event("change", { bubbles: true }));
}

function init(context) {
	onEvent(context, "[data-multiref-add]", "click", onAddItem);
	onEvent(context, "[data-multiref-remove]", "click", onRemoveItem);
}

export { init };